import { SHOP_ROLE_ASSIGNMENTS, type ShopRole } from '../@constants/permissions';

export const SHOP_INVITATION_STATUSES = [
  'pending',
  'accepted',
  'declined',
  'expired',
  'revoked',
] as const;
export type ShopInvitationStatus = (typeof SHOP_INVITATION_STATUSES)[number];
export type ShopInvitationRole = Exclude<ShopRole, 'owner'>;
export const SHOP_INVITATION_ROLES: readonly ShopInvitationRole[] =
  SHOP_ROLE_ASSIGNMENTS.owner as readonly ShopInvitationRole[];

export interface ShopInvitation {
  invitationId: string;
  shopId: string;
  invitee: { emailNormalized: string; emailHash: string; existingUid?: string };
  role: ShopInvitationRole;
  permissions: string[];
  status: ShopInvitationStatus;
  security: {
    tokenHash: string;
    expiresAt: unknown;
    acceptedAt?: unknown;
    revokedAt?: unknown;
    declinedAt?: unknown;
  };
  createdBy: string;
  createdAt: unknown;
  updatedAt: unknown;
  operationId: string;
}
